import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { DEFAULT_BASE_COLOR, DEFAULT_HIGHLIGHT_COLOR } from './consts'
import type { BaseSkeletonProps, BaseSkeletonThemeProps } from './types'

const BaseSkeletonTheme = (props: BaseSkeletonThemeProps) => {
  return <SkeletonTheme baseColor={DEFAULT_BASE_COLOR} highlightColor={DEFAULT_HIGHLIGHT_COLOR} {...props} />
}

const BaseSkeletonItem = (props: BaseSkeletonProps) => {
  return <Skeleton {...props} />
}

/**
 * Skeleton component with default colors
 *
 * @example
 * <BaseSkeleton count={3} />
 * <BaseSkeleton count={3} width={200} />
 * <BaseSkeleton count={3} height={100} />
 *
 * @example
 * <BaseSkeleton.Theme color="#333" highlightColor="#555">
 *  <BaseSkeleton.Item count={3} />
 * </BaseSkeleton.Theme>
 */
const BaseSkeleton = (props: BaseSkeletonProps) => (
  <BaseSkeletonItem baseColor={DEFAULT_BASE_COLOR} highlightColor={DEFAULT_HIGHLIGHT_COLOR} {...props} />
)

BaseSkeleton.Theme = BaseSkeletonTheme
BaseSkeleton.Item = BaseSkeletonItem

export { BaseSkeleton }
